import React from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <div className="footer padded-sec"> 
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-xl-3 col-lg-6 col-sm-6 col-xs-12'>
              <Link to="/"><div className='ftr-logo'> 
                <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/ftr-logo.png" alt="Mercy Memorial School, Kanpur" /> </LazyLoad>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14292.283786109503!2d80.325942!3d26.421187!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399c4711aaaaaaab%3A0xc8d01f6dec7175d0!2sMercy%20Memorial%20School%20(Junior%20Wing)!5e0!3m2!1sen!2sin!4v1743139460629!5m2!1sen!2sin" width="100%" height="150px" frameborder="0" allowfullscreen=""></iframe>

              </div>
              </Link>
            </div> 
            <div className='col-xl-2 col-lg-6 col-sm-6 col-xs-12'>
              <h3>Quick Links</h3>
              <div className='quick-link'>
                <ul>
                  <li><Link to="/AboutUs"><i className="bi bi-caret-right-fill"></i> About Us</Link></li>
                  <li><Link to="/ContactUs"><i className="bi bi-caret-right-fill"></i>Contact Us </Link></li>
                  <li><Link to="/ErpSoftware"><i className="bi bi-caret-right-fill"></i>ERP Software</Link></li>
                  <li><Link to="/Pphelp"><i className="bi bi-caret-right-fill"></i>Parent Portal</Link></li>
                  { /*  <li><Link to="https://mercymemorial.campussoft.net/" target="_blank"><i className="bi bi-caret-right-fill"></i>Online Fee Payment</Link></li> */}
                  <li><Link to="/Tc"><i className="bi bi-caret-right-fill"></i>Transfer Certificate</Link></li>
                </ul>
              </div>
            </div>
            <div className='col-xl-3 col-lg-6 col-sm-6 col-xs-12 address'>
              <h3>Address</h3>
              <p><i className="bi bi-house-door-fill"></i> <span><Link to="https://maps.app.goo.gl/ghwphZqLkPpr1E5y7" target="_blank">1272 - 1427 - Y Block, Kidwai Nagar, Uttar Pradesh - 208011</Link></span></p>
              <p><i className="bi bi-telephone-fill"></i> <span><a href="tel: +91-512-4000406">+91-512-4000406</a><br /><a href="tel: +91-512-4000407">4000407</a></span></p>
              <p><i className="bi bi-envelope-fill"></i> <span> <a href="mailto:mercyknp83@gmail.com">mercyknp83@gmail.com</a></span></p>
            </div>
            <div className='col-xl-4 col-lg-6 col-sm-6 col-xs-12'>
              <div className='ph-flex'>
                <div className="app-cont">
                  <h3>Download Mobile App</h3>
                  <p>  Applying leave of absence on behalf of your ward is easy with the app. You will get instant notification on your app of leave's approval or rejection.</p>
                  <div>
                    <a href="https://apps.apple.com/in/app/campuscare/id1034721587" target="_blank">
                      <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/apple.png" className="img-fluid" /></LazyLoad>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.campuscare.entab.ui" target="_blank">
                      <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/playstore.png" className="img-fluid" /></LazyLoad>
                    </a>
                  </div>
                  <p className="link"><Link to="https://mercymemorial.campussoft.net/" target="_blank"> mercymemorial.campussoft.net </Link></p>
                </div>
                <div className='mobile-icon'>
                  <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/mobile-icon.png" className="img-fluid" /></LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='copyright'>
        ©️ Copyright 2025 by Mercy Memorial School, Kidwai Nagar, Kanpur Created by  <Link to="https://www.entab.in/" target="_blank">Entab Infotech: CampusCare®️ </Link>
      </div>
    </>
  );
}

export default Footer;
